module.exports = __webpack_public_path__ + "img/happybrain_info2.1654b6aa.jpg";